const Footer = ()=> {
return (
    <footer class="site-footer">
    <p>&copy; 2024 TheRolePlayer. All rights reserved.</p>
    <p>Built by Moksh Shah, Arav Arora, and Viswa Subramaniam</p>
</footer>
);

}

export default Footer;